import '~shared/components/CopyableInputControl/CopyableInputControl.scss';

import * as React from 'react';

import { SlCopyButton } from '@shoelace-style/shoelace/dist/react';
import { translate } from '~l10n/client';
import cx from 'classnames';

import {
  IconCheckmark,
  IconCopy2,
  IconX,
} from '~shared/components/icons/standard';
import TextInput from '~shared/components/TextInput';

interface CopyableInputControlProps {
  label: string;
  value: string;
  textInputClass?: string;
}

export function CopyableInputControl({
  label,
  value,
  textInputClass,
}: CopyableInputControlProps) {
  return (
    <div className="copyable-input-control">
      <label htmlFor={`${label}-value`} className="label">
        {label}
      </label>
      <TextInput
        readOnly
        id={`${label}-value`}
        value={value}
        className={cx('textInput', textInputClass)}
      />
      <div className="copy">
        <SlCopyButton
          value={value}
          copy-label={translate('Copy')}
          success-label={translate('Copied')}
          error-label={translate('Error')}
        >
          <div slot="error-icon">
            <IconX />
          </div>
          <div slot="copy-icon" className="text-grey-900">
            <IconCopy2 />
          </div>
          <div slot="success-icon">
            <IconCheckmark />
          </div>
        </SlCopyButton>
      </div>
    </div>
  );
}
